var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 26,
    fill: "url(#paint0_linear_1864_696)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0826 31.9563L36.8082 27.466H32.2694V24.5521C32.2694 23.3236 32.9034 22.1262 34.9364 22.1262H37V18.3034C37 18.3034 35.1272 18 33.3367 18C29.5985 18 27.1553 20.1505 27.1553 24.0437V27.466H23V31.9563H27.1553V42.8113C27.9884 42.9354 28.8424 43 29.7123 43C30.5822 43 31.4362 42.9354 32.2694 42.8113V31.9563H36.0826Z",
    fill: "#5250ED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1864_696",
    x1: -23.8313,
    y1: 18.0425,
    x2: 35.502,
    y2: 71.4532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f3278a47006a667adc6c058de9d2c2d2.svg";
export { ForwardRef as ReactComponent };